import { Timestamp } from 'rxjs';
import { BaseEntity } from 'src/app/entity/base-entity';
import { Role } from './role';

export class User extends BaseEntity {
  email: string;
  password: string;
  name: string;
  surname: string;

  role: Role;

  idGuid: string;
  licenceId: number;
}
